import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";

interface StaticsProps {
    totalNumber: number | null;
    hasLearnNumber: number | null;
    notLearnNumber: number | null;
    onClick: (params: any) => void;
}

export default function Statics({
    totalNumber,
    hasLearnNumber,
    notLearnNumber,
    onClick
}: StaticsProps) {
    return (
        <div className={style.root}>
            <div
                className={classNames(style.statics)}
                onClick={() => onClick({ status: "" })}>
                <em>{totalNumber || "0"}</em>课程人数
            </div>
            <div
                className={classNames(style.statics)}
                onClick={() => onClick({ status: "1" })}>
                <em>{hasLearnNumber || "0"}</em>已学习
            </div>
            <div
                className={classNames(style.statics)}
                onClick={() => onClick({ status: "0" })}>
                <em>{notLearnNumber || "0"}</em>未学习
            </div>
        </div>
    );
}
